import { render, staticRenderFns } from "./alarm-infomation.vue?vue&type=template&id=0b8b6c94"
import script from "./alarm-infomation.vue?vue&type=script&lang=js"
export * from "./alarm-infomation.vue?vue&type=script&lang=js"
import style0 from "./alarm-infomation.vue?vue&type=style&index=0&id=0b8b6c94&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports